module["exports"] = ["ул.", "улица", "проспект", "пр.", "площадь", "пл."];